import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { CasesGeneralClaimsProps } from './props';
import { CasesGeneralClaims } from '../../../../../../shared/types/modules/cases-general';
import {
    asyncGetParamByCode,
    asyncGetParams,
} from '../../../../../../services/param.service';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';

export const useCasesGeneralClaims = ({
    data,
    onChangeData,
    onChangeFormik,
}: CasesGeneralClaimsProps) => {
    const [status, setStatus] = useState<ISelect[]>([]);
    const observation = '';
    const description = '';
    const dateEvent = '';

    const onSubmit = (data: CasesGeneralClaims) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    const getStatus = (statusCode?: string) => {
        statusCode = statusCode || `${ParamEnum.PQR_STATUS}_ABI`;

        asyncGetParamByCode(statusCode).then((item) => {
            setStatus(item ? [item] : []);
            formik.setFieldValue('status', item?.id);
        });
    };

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('dateEvent', data?.dateEvent || '');
        formik?.setFieldValue('status', data?.status || '');
        formik?.setFieldValue('description', data?.description || '');
        formik?.setFieldValue('observation', data?.observation || '');
        formik?.setFieldValue(
            'correspondenceFiling',
            data?.correspondenceFiling || ''
        );
    }, [data]);

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_STATUS).then((params) =>
            setStatus(params)
        );
    }, []);
    useEffect(() => {
        getStatus();
    }, []);

    return {
        formik,
        status,
        dateEvent,
        description,
        observation,
    };
};
